import { Routes } from '@angular/router';
import { DashboardHomeComponent } from 'src/app/core/pages/dashboard-home/dashboard-home.component';
import { feedItemsResolver } from 'src/app/shared/resolvers/feed-item.resolver';
import { DashboardLayoutComponent } from 'src/app/core/layouts/dashboard-layout/dashboard-layout';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'prefix',
    component: DashboardLayoutComponent,
    children: [{
      path: '',
      pathMatch: 'full',
      component: DashboardHomeComponent,
      resolve: { feedItems: feedItemsResolver }
    }],
  }
];
